export default __webpack_public_path__ + "static/media/ir3Logo.31186e8c.svg";